<template>
  <div class="variant-popup">
    <v-card-title>
      <img v-if="detail.product_variant.status !== 'hide'" :src='formatImagePath(detail.product_variant.image_path, "300")' alt='Image'>
      <div v-else class="variant-not-found text-xs-center">
        <h3 class="headline">{{ $t('product_not_found') }}</h3>
      </div>
    </v-card-title>
    <v-card-text class="pl-2 pt-2 pr-2 pb-0">
      <div v-for='(attr, index) in getProductDetail.product_attribute' :key='attr.name'>
        <v-layout row wrap>
          <v-flex xs4>
            <v-subheader>{{ attr.name }}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <v-select
              :items='attr.value'
              v-model='variantDefault[index].default'
              v-on:input='changeAttribute(attr.name, variantDefault[index].default)'
              single-line
            ></v-select>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row wrap v-if="detail.product_variant.status !== 'hide'">
        <v-flex xs4>
          <v-subheader>{{ $t('Quantity') }}</v-subheader>
        </v-flex>
        <v-flex xs8>
            <div v-if="parseInt(detail.use_stock) === 0 || (parseInt(detail.use_stock) === 1 && (detail.product_variant.stock > 0 || detail.product_variant.stock === '' || detail.product_variant.stock === null) && detail.product_variant.status === 'show')">
              <v-btn class="ma-0" icon v-on:click="decreaseQty()">
                <v-icon color="primary">remove_circle</v-icon>
              </v-btn>
              <div class='qty'>
                <v-select
                  :items='inputQty'
                  v-model='qty'
                  single-line
                ></v-select>
              </div>
              <v-btn class="ma-0" icon v-on:click="increaseQty()">
                <v-icon color="primary">add_circle</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <v-chip color='orange' text-color='white'>
              {{ $t('Out_of_stock') }}
              </v-chip>
            </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap v-if="detail.product_variant.status !== 'hide'">
        <v-flex xs4>
          <v-subheader>{{ $t('Price') }}</v-subheader>
        </v-flex>
        <v-flex xs8 v-if='$i18n.locale() === "th"' class='price-variant'>
          <v-layout row wrap>
            <v-flex d-flex xs12>
              <span class='sale-price'>{{ formatPrice(detail.product_variant.normal_price, detail.product_variant.special_price, detail.product_variant.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
            </v-flex>
            <v-flex d-flex xs12>
              <span v-if='detail.product_variant.special_price || (detail.product_variant.member_price && getParams.member === 1)' class='original-price'>{{ formatPrice(detail.product_variant.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_th) }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs8 v-else class='price-variant'>
          <v-layout row wrap>
            <v-flex d-flex xs12>
              <span class='sale-price'>{{ formatPrice(detail.product_variant.normal_price, detail.product_variant.special_price, detail.product_variant.member_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
            </v-flex>
            <v-flex d-flex xs12>
              <span v-if='detail.product_variant.special_price || (detail.product_variant.member_price && getParams.member === 1)' class='original-price'>{{ formatPrice(detail.product_variant.normal_price) | currency(getCurrency.code, getCurrency.display, getCurrency.position, getCurrency.name_en) }}</span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pl-0 pt-0 pr-0 pb-1" v-if="detail.product_variant.status !== 'hide'">
      <button-bottom v-bind:page="page" v-bind:quantity="qty" v-bind:status="detail.product_variant.status"></button-bottom>
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getSymbolFromCurrency from 'currency-symbol-map'

import ButtonBottom from './bottom/index.vue'

export default {
  name: 'VariantModal',
  components: {
    ButtonBottom
  },
  props: {
    variantDefault: {
      default: function () { return [] },
      type: Array
    },
    variantDetail: {
      default: function () { return [] },
      type: Object
    },
    param: {
      default: function () { return '' },
      type: String
    }
  },
  data () {
    return {
      qty: 1,
      page: 'modal',
      product_variant: [],
      inputQty: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      newParam: this.param,
      detail: this.variantDetail
    }
  },
  computed: {
    ...mapGetters([
      'getCurrency',
      'getProductDetail',
      'getParams'
    ])
  },
  methods: {
    ...mapActions({
      getProductVariantAPI: 'getProductVariantAPI'
    }),
    decreaseQty () {
      if (this.qty > 1) {
        this.qty -= 1
      }
    },
    increaseQty () {
      if (this.qty < 20) {
        this.qty += 1
      }
    },
    formatPrice (normalPrice, specialPrice, memberPrice) {
      var value = ''
      if (memberPrice && this.getParams.member === 1) {
        value = memberPrice
      } else if (specialPrice) {
        value = specialPrice
      } else {
        value = normalPrice
      }

      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    changeAttribute (name, val) {
      var substrFirst = this.newParam.split('attribute[' + name + ']=')
      var substrSecond = substrFirst[1].split('&').slice(1).join('&')
      this.newParam = substrFirst[0] + 'attribute[' + name + ']=' + val
      if (substrSecond) {
        this.newParam += '&' + substrSecond
      }
      this.getProductVariantAPI(this.newParam).then(results => {
        this.detail = results
      })
    },
    formatImagePath (image, size) {
      return process.env.IMAGE_SERVICE_URL + '/image/' + size + 'x0/' + image
    }
  },
  filters: {
    currency (value, code, display, position, name) {
      var text = ''
      if (display === 'iso') {
        text = code
      } else if (display === 'symbol') {
        text = getSymbolFromCurrency(code)
      } else {
        text = name
      }
      if (position === 'prefix') {
        return text + ' ' + value
      } else {
        return value + ' ' + text
      }
    }
  }
}
</script>

<style type='text/css' lang='scss'>
.variant-popup {
  .layout.wrap {
    height: 40px;
  }
  .column {
    width: 100%;
    display: flex;
    align-items: center;
  }
  .card__title {
    padding: 0;
    img {
      margin: 0 auto;
      width: 100%;
    }
  }
  .card__text {
    .flex {
      display: flex;

      > div {
        margin: auto 0px;
        width: 100%;
      }
    }
  }
  .price-variant {
    .sale-price {
      font-size: 16px;
      color: green;
      margin-right: 5px;
      font-weight: bold;
    }
    .original-price {
      font-size: 12px;
      color: gray;
      text-decoration: line-through;
    }
  }
  .qty {
    display: inline-block;
    font-size: 20px;
    width: 49%;
    margin: 0 10px;
    input {
      text-align: center;
    }
  }
  select {
    width: 100%;
    border: #ccc solid 1px;
    padding-left: 5px;
    background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right;
    background-position-x: 95%;
  }
  .menu {
    .menu__content {
      top: 0 !important;
      left: inherit !important;
      right: 0;
    }
  }
  .input-group {
    border: #ccc solid 1px;
    padding-top: 0;
    .input-group__input {
      padding-left: 5px;
    }
    .input-group__details {
      display: none;
    }
  }
  .sub-color {
    color: blue;
  }
  .variant-not-found {
    width: 100%;
    margin: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopCategory/productVariants/index.vue